/**
 * The principles shown on the About page. Four is the right number - enough to
 * say something, few enough that each one is read.
 */

export interface Principle {
  readonly id: string;
  readonly title: string;
  readonly body: string;
}

export const principles: readonly Principle[] = [
  {
    id: 'ship-early',
    title: 'Something real, quickly',
    body: 'We like to have working software in front of you within the first few weeks. Not a slide deck, not a clickable mock - something live that you can click around and react to. What you tell us then is worth far more than anything we would have guessed without it.',
  },
  {
    id: 'whole-stack',
    title: 'We look after the whole thing',
    body: 'Interface, API, data model, infrastructure, deployment. A small team holding all of it makes better calls than a big one passing tickets between specialisms - and there is nobody to hand the blame to, which we rather like.',
  },
  {
    id: 'measure',
    title: 'If we say it, we measured it',
    body: 'If we tell you something is faster, cheaper or more accurate, there is a benchmark behind it. Where we are not sure, we will say so plainly. You should never have to work out how much of what we tell you to believe.',
  },
  {
    id: 'handover',
    title: 'You should not need us for long',
    body: 'The work is done when your team can run, change and deploy it all without us. Documentation, tests and a proper handover are part of the job, not a favour at the end of it. We would rather you came back because you wanted to.',
  },
];
